import data from './data'
import components from './components'
import methods from './methods'
import computed from './computed'
import mounted from './mounted'

export default {
  data,
  components,
  methods,
  mounted,
  computed,
  resourcePath: '/v1/dweller/accountability'
}



// WEBPACK FOOTER //
// ./src/app/dweller/accountability/resources/index.js